var env = {
    // Api
    API_URL: "https://www.districloud.net/app/service/rest/ws.php?action=api_client",
    API_ID: "777",
    API_TOKEN: "09cab42c74bd353979d87594db9ac7148771da62",
}

export default env
